import { AirportInfo, SectorInfo } from '@/src/types/flight'

// New utility for multiple sections

export type AirportMap = Record<string, AirportInfo>

/**
 * Returns an array of route summaries for each section.
 */
export function getRouteSummaries(secs: SectorInfo[], ap: AirportMap): string[] {
    return secs.map(sec => {
        const fromInfo = ap[sec.from]
        const toInfo = ap[sec.to]
        if (!fromInfo || !toInfo) {
            return 'Invalid route data'
        }
        return `${fromInfo.c} →  ${toInfo.c}`
    })
}
